// Generic row-click detail/edit Sheet for capture entities. Holds the chrome
// (right-side panel, header, scrollable body, sticky footer with Save/Cancel)
// so each entity form (RFI, interaction, workstream) and, from Phase 5, the
// per-entity documents panel only supply field rows. Edit and create reuse the
// same shell — create just opens it with empty fields.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraOverlayDrawer } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
export function EntityDetailSheet({ open, onOpenChange, entity, title, description, onSave, saveDisabled, saving, saveLabel, children }) {
    // data-* keys other than data-testid aren't part of the declared prop type,
    // so widen via a typed variable (object literals reject unknown keys).
    const contentProps = {
        'data-entity': entity
    };
    return /*#__PURE__*/ _jsx(SpecraOverlayDrawer, {
        open: open,
        onOpenChange: onOpenChange,
        title: title,
        description: description,
        testId: Testids.capture.entitySheet,
        contentProps: contentProps,
        // Wider panel than the drawer's md default, matching the old sheet.
        className: "sm:max-w-xl",
        bodyProps: {
            className: 'space-y-4'
        },
        footerProps: {
            cancelLabel: 'Cancel',
            onCancel: ()=>onOpenChange(false),
            confirmLabel: saving ? 'Saving…' : saveLabel ?? 'Save',
            onConfirm: onSave,
            confirmProps: {
                disabled: saveDisabled || saving,
                'data-testid': Testids.capture.entitySheetSaveButton
            }
        },
        children: children
    });
}
// Small labeled-field wrapper shared by the entity forms — keeps the forms a
// flat list of <LabeledField label><control/></LabeledField> rows.
export function LabeledField({ label, htmlFor, children }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-1.5",
        children: [
            /*#__PURE__*/ _jsx("label", {
                htmlFor: htmlFor,
                className: "text-sm font-medium",
                children: label
            }),
            children
        ]
    });
}
